import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Palette, Wind, Heart } from 'lucide-react';
export function UniqueFeatures() {
  return <section className="relative z-10 px-6 py-16 md:py-24" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-white font-heading mb-12" data-id="element-92">
          Lo que hace <span className="text-gold" data-id="element-93">único</span> a este eBook
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-94">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="glass-card p-8 border-t-4 border-t-gold" data-id="element-95">
            <div className="flex items-center mb-6" data-id="element-96">
              <Sparkles className="w-6 h-6 text-gold mr-3" data-id="element-97" />
              <h3 className="text-2xl font-bold text-white font-heading" data-id="element-98">
                Doble versión
              </h3>
            </div>
            <p className="text-mutedPurple mb-6 font-body" data-id="element-99">
              El lenguaje correcto para cada etapa. Sabemos que un niño de 3
              años no procesa igual que uno de 6. Por eso, cada ficha diaria
              incluye:
            </p>
            <div className="space-y-4 font-body" data-id="element-100">
              <div className="bg-white/5 rounded-lg p-4 border border-white/5" data-id="element-101">
                <h4 className="font-bold text-gold mb-1" data-id="element-102">
                  🌱 Versión Semilla (3–4 años):
                </h4>
                <p className="text-sm text-warmWhite" data-id="element-103">
                  Afirmaciones cortas, rítmicas y muy sencillas.
                </p>
              </div>
              <div className="bg-white/5 rounded-lg p-4 border border-white/5" data-id="element-104">
                <h4 className="font-bold text-gold mb-1" data-id="element-105">
                  ⭐ Versión Lucero (5–6 años):
                </h4>
                <p className="text-sm text-warmWhite" data-id="element-106">
                  Afirmaciones con un poco más de profundidad para su
                  razonamiento.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="glass-card p-8 border-t-4 border-t-softPink" data-id="element-107">
            <div className="flex items-center mb-6" data-id="element-108">
              <Sparkles className="w-6 h-6 text-softPink mr-3" data-id="element-109" />
              <h3 className="text-2xl font-bold text-white font-heading" data-id="element-110">
                Aprender haciendo
              </h3>
            </div>
            <p className="text-mutedPurple mb-6 font-body" data-id="element-111">
              Nada de aburrimiento. Cada afirmación viene con una actividad
              express de 5 a 15 minutos:
            </p>
            <ul className="space-y-4 font-body" data-id="element-112">
              <li className="flex items-start" data-id="element-113">
                <Palette className="w-5 h-5 text-softPink mr-3 mt-0.5 flex-shrink-0" data-id="element-114" />
                <span className="text-warmWhite" data-id="element-115">
                  Dibujos que liberan creatividad.
                </span>
              </li>
              <li className="flex items-start" data-id="element-116">
                <Wind className="w-5 h-5 text-softPink mr-3 mt-0.5 flex-shrink-0" data-id="element-117" />
                <span className="text-warmWhite" data-id="element-118">
                  Juegos de respiración para la calma.
                </span>
              </li>
              <li className="flex items-start" data-id="element-119">
                <Heart className="w-5 h-5 text-softPink mr-3 mt-0.5 flex-shrink-0" data-id="element-120" />
                <span className="text-warmWhite" data-id="element-121">
                  Dinámicas de gratitud y amabilidad.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}